export const almacenModel = {
  al: null,
  su: null,
  na: null,
  ta: '',
  dt: '',
  st: false,
};
